import type { HardgoodsInventoryRow } from "~produce/inventory/hardgoods/types";

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface HardgoodsInventoryState {
	addDialogOpen: boolean;
	adjustDialogOpen: boolean;
	adjustItem: HardgoodsInventoryRow | null;
	moveDialogOpen: boolean;
	moveItem: HardgoodsInventoryRow | null;
	revision: number;
	selectedItem: HardgoodsInventoryRow | null;
}

const initialState: HardgoodsInventoryState = {
	addDialogOpen: false,
	adjustDialogOpen: false,
	adjustItem: null,
	moveDialogOpen: false,
	moveItem: null,
	revision: 0,
	selectedItem: null
};

export const hardgoodsInventorySlice = createSlice({
	initialState,
	name: "hardgoodsInventory",
	reducers: {
		closeAddDialog: (state) => {
			state.addDialogOpen = false;
		},
		closeAdjustDialog: (state) => {
			state.adjustDialogOpen = false;
			state.adjustItem = null;
		},
		closeMoveDialog: (state) => {
			state.moveDialogOpen = false;
			state.moveItem = null;
		},
		openAddDialog: (state) => {
			state.addDialogOpen = true;
		},
		openAdjustDialog: (state, action: PayloadAction<HardgoodsInventoryRow>) => {
			state.adjustDialogOpen = true;
			state.adjustItem = action.payload;
		},
		openMoveDialog: (state, action: PayloadAction<HardgoodsInventoryRow>) => {
			state.moveDialogOpen = true;
			state.moveItem = action.payload;
		},
		revisionBumped: (state) => {
			state.revision += 1;
		},
		setSelectedItem: (state, action: PayloadAction<HardgoodsInventoryRow | null>) => {
			state.selectedItem = action.payload;
		}
	}
});

export const {
	closeAddDialog,
	closeAdjustDialog,
	closeMoveDialog,
	openAddDialog,
	openAdjustDialog,
	openMoveDialog,
	revisionBumped,
	setSelectedItem
} = hardgoodsInventorySlice.actions;

export default hardgoodsInventorySlice.reducer;
